module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-1500-Active-Rumble-c4db22a95f24d1d4b20fe3c4f1f54de5.png";